import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ArquivosManager } from 'src/app/components/arquivos-manager';
import { ServicoDefaultPage } from 'src/app/components/servico-default-page';
import { ServicoCredenciamentoImobiliarias } from 'src/app/models/credenciamento-imobiliarias';
import { IdentificacaoAtendimento } from 'src/app/models/Servico.model';
import { ServicoService } from 'src/app/services/servico.service';
import { renameDefaultFilenames } from 'src/app/util/rename-default-filenames';

@Component({
  selector: 'app-credenciamento-imobiliarias',
  templateUrl: './credenciamento-imobiliarias.component.html',
  styleUrls: ['./credenciamento-imobiliarias.component.css'],
})
export class CredenciamentoImobiliariasComponent
  extends ServicoDefaultPage
  implements OnInit, OnDestroy
{
  arquivosManager = new ArquivosManager();

  formSolicitante!: FormGroup;
  formServico!: FormGroup;

  constructor(
    private messageService: MessageService,
    private fb: FormBuilder,
    servicoService: ServicoService,
    router: Router
  ) {
    super(servicoService, router);
  }

  ngOnInit(): void {
    this.getServico('credenciamento-imobiliarias', () => {
      this._inicializarFormSolicitante();
      this._inicializarForm();
    });
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach((s) => s.unsubscribe());
  }

  putDadosSolicitante() {
    this.ACTIVE_INDEX = 1;
    this.formSolicitante.disable();
  }

  concluirCadastro() {
    this.loading = true;

    let formulario: ServicoCredenciamentoImobiliarias = {
      ...this.formSolicitante.value,
      servicoValores: this.servico?.servicoFormulario.map((campo) =>
        Number(this.formServico.value[campo.id].id)
      ),
    };

    const formData = new FormData();
    var arquivos = renameDefaultFilenames(this.arquivosManager.anexos);
    arquivos.forEach((anexo) => {
      formData.append('arquivos', anexo, anexo.name);
    });

    formData.append(
      'formAtendimento',
      new Blob([JSON.stringify(formulario)], { type: 'application/json' })
    );

    this.servicoService
      .postServicoCredenciamentoImobiliaria(formData)
      .subscribe({
        next: ({ id, ano, hash }) => {
          this.loading = false;
          this.dadosSolicitacao = new IdentificacaoAtendimento(id, ano, hash);
          this.ACTIVE_INDEX = 2;
        },
        error: (error) => {
          this.loading = false;

          if (error.error.message) {
            this.messageService.add({
              severity: 'error',
              detail: error.error.message,
            });
          }

          if (error.error.messages) {
            error.error.messages.forEach((message: any) => {
              this.messageService.add({
                severity: 'error',
                detail: message.message,
              });
            });
          }
        },
      });
  }

  _inicializarFormSolicitante() {
    this.formSolicitante = this.fb.group({
      cnpj: ['', [Validators.required, Validators.pattern(/^(\D*\d){14}\D*$/)]],
      razaoSocial: ['', [Validators.required]],
      creci: ['', [Validators.required]],
      numeroConvenio: ['', [Validators.required]],
      telefone: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      responsavel: ['', [Validators.required]],
      emailResponsavel: ['', [Validators.required, Validators.email]],
      declaracaoVeracidade: [null, Validators.required],
      declaracaoAceite: [null, Validators.required],
    });
  }

  _inicializarForm() {
    const grupo: any = {};

    this.servico?.servicoFormulario.forEach((campo) => {
      grupo[campo.id] = ['', Validators.required];
    });

    this.formServico = this.fb.group(grupo);

    this.servico?.servicoAnexos.forEach((anexo) =>
      this.arquivosManager.inicializarCategoriaArquivo(anexo.nomeAnexo)
    );

    this.arquivosManager.inicializarCategoriaArquivo(
      this.arquivosManager.ANEXO_DOCUMENTO_OUTROS
    );
  }

  isArquivosObrigatoriosSelecionados() {
    return this.servico?.servicoAnexos
      .filter((s) => s.envioObrigatorio)
      .every((s) => this.arquivosManager.isCategoriaFilled(s.nomeAnexo));
  }
}
